import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { adminApi } from "../Service/admin";
import AlertReducer from './Reducers/AppSlice'
import UserSliceReducer, { signOut } from "./Reducers/UserSlice";

const combinedReducers = combineReducers({
  user: UserSliceReducer,
  app: AlertReducer,

  [adminApi.reducerPath]: adminApi.reducer,
});

const rootReducer = (state, action) => {
  // Reset state on signout
  if (signOut.match(action)) {
    // eslint-disable-next-line no-param-reassign
    state = undefined
  }
  return combinedReducers(state, action)
}

const Store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      adminApi.middleware,
    ]),
});

setupListeners(Store.dispatch);

export default Store;
